import B3Request from '../../request/b3Fetch';

const getProductBySkuQuery = `query GetProductBySku($sku: String!) {
  site {
    product(sku: $sku) {
      entityId
      name
      sku
      path
      type  # Add this to get the product type
      prices {
        price {
          value
        }
      }
      defaultImage {
        urlOriginal
      }
      variants {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}`;

export const getProductBySku = (sku: string) =>
    B3Request.graphqlBCProxy({
        query: getProductBySkuQuery,
        variables: { sku },
    });
